import(/* webpackMode: "eager" */ "/app/src/app/[locale]/group-of-company/error.tsx");
